import { render, staticRenderFns } from "./ClientsConfig.vue?vue&type=template&id=77d9e2ff"
import script from "./ClientsConfig.vue?vue&type=script&lang=js"
export * from "./ClientsConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports